import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from './start-end-call.module.scss';
import PhoneCall from '@/assets/icons/phone-call-01.svg?react';
import PhoneHangUp from '@/assets/icons/phone-hang-up.svg?react';
import Icon from '@ant-design/icons';
import clsx from 'clsx';

interface StartEndCallProps {
  type: 'start' | 'end';
  phone: string;
}

export function StartEndCall({ type, phone }: StartEndCallProps) {
  const { t } = useTranslation('conversations');
  const renderIcon =
    type === 'start' ? (
      <PhoneCall
        data-testid="phone-call-icon"
        stroke={styles.startCallIconColor}
        width={16}
        height={16}
      />
    ) : (
      <PhoneHangUp
        data-testid="phone-hang-up-icon"
        stroke={styles.endCallIconColor}
        width={16}
        height={16}
      />
    );
  return (
    <Flex
      wrap
      gap={28}
      align="center"
      className={clsx(
        styles.container,
        type === 'start' ? styles.startContainer : styles.endContainer
      )}
    >
      <p className={styles.startEndText}>
        {t(type === 'start' ? 'drawer.transcript.start' : 'drawer.transcript.end')}
      </p>
      <Icon component={() => renderIcon} />
      <p className={styles.phone}>{phone}</p>
    </Flex>
  );
}
